import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from '#/renderer/router';

import Slider from 'react-slick';
import { CrossPrev, CrossNext } from '../../../helpers/svg';

import { cuotaFormat, currencyFormat, imgFormat } from '../../../helpers/formatter';
import helpers from '../../../helpers/product';
import useStores from '../../../store/StoreHook';

const CrossBox = ({ data = {}, url = '', addToCart }) => {
  const { orderStore } = useStores();
  const [aceptaCuotas, setAceptaCuotas] = useState(false);
  const [formatoCuotas, setFormatoCuotas] = useState('');

  const prodItems = { items: data.items };
  helpers.ordenar(prodItems);
  const item = prodItems.items.find(it => it.available && it.buyable);

  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      if (orderStore.getCartConfig.success) {
        const min = orderStore.getCartConfig.data.data.precioMinimoCuotas || 0;
        setAceptaCuotas(item.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price >= (min * 100));
        setFormatoCuotas(orderStore.getCartConfig.data.data.formatoCuotas || '');
      }
    }
    if (item) {
      init();
    }
  }, []);

  if (item) {
    const hasPromo = item.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price !== item.pricing[process.env.NEXT_PUBLIC_CURRENCY].list_price;
    const atributesMap = helpers.convertAttributes(item.attributes);
    const cuotas = atributesMap['attr-conf-pagocuotas'];
    const textoCuota = atributesMap['attr-texto-cuotas'];
    let label = 'Precio';
    let labelContado = '';
    let labelCuota = '';
    let paymentLabel = hasPromo ? 'OFERTA' : atributesMap['attr-texto-precio'];
    let priceclass = 'cross--box--price';
    if (cuotas === 'SI' && textoCuota && aceptaCuotas) {
      label = atributesMap['attr-titulo-cuotas'] || `${label} financiado`;
      const precioCuota = parseFloat(textoCuota);
      if (Number.isNaN(precioCuota)) {
        // eslint-disable-next-line react/no-danger
        labelCuota = <p className="price-cuota" dangerouslySetInnerHTML={{ __html: textoCuota }} />;
      } else {
        const cuota = currencyFormat(item.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price / precioCuota).split('.');
        labelCuota = cuotaFormat(cuota, textoCuota, formatoCuotas);
      }
      if (hasPromo) {
        labelContado = <p className="price-before">Precio de contado</p>;
      } else {
        paymentLabel = 'Precio de contado';
      }
      priceclass = 'cross--box--price cuota';
    }

    let currencyText = currencyFormat(item.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price).split('.');
    const image = item.images && item.images[0] ? `${process.env.NEXT_PUBLIC_CDN_PATH}${item.images[0]}` : '/media/layout/noimage.jpg';
    const tipoProducto = atributesMap['attr-conf-tipoproducto'];
    const precioMensual = atributesMap['attr-conf-precio-mensual'];
    const fullname = item.locales && item.locales[process.env.NEXT_PUBLIC_LOCALE] ? item.locales[process.env.NEXT_PUBLIC_LOCALE].name.replace(/<br>/, '\n').replace(/<br\/>/, '\n').replace(/\\n/, '\n').split('\n')
      .map((str, idx) => <span key={idx}>{str}</span>) : '';
    if (tipoProducto === 'ADDONS' || tipoProducto === 'PLAN' || tipoProducto === 'GARANTIA') {
      if (precioMensual) {
        const subtotal = parseFloat(precioMensual).toFixed(2).toString().replace('.', '');
        currencyText = currencyFormat(subtotal).split('.');
        label += ' mensual';
      }
    }
    return (
      <article className="cross--box">
        <Link to={`/product${tipoProducto === 'OTRO' ? 'x' : ''}/${item.locales[process.env.NEXT_PUBLIC_LOCALE].seo.name}/${url}`}>
          <h3>{fullname}</h3>
          <picture>
            <img src={imgFormat('210x180', image)} alt="crossImage" />
          </picture>
          <section className={priceclass}>
            <b>{label}</b>
            {labelCuota}
            {labelContado}
            <p className="price-before">{paymentLabel}</p>
            <p className="price">
              <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
              <span>{(currencyText ? currencyText[0] : '')}.</span>
              <span className="symbol">{(currencyText ? currencyText[1] : '')}</span>
            </p>
          </section>
        </Link>
        <a className="add" onClick={() => addToCart(item)}>
          <span>Añadir</span>
        </a>
      </article>
    );
  }
  return null;
};

const UI = ({ products, addOnsList, tipo, addToCart }) => {
  if (products && products.length) {
    const crossSettings = {
      infinite: products.length > 4,
      autoplay: false,
      autoplaySpeed: 4000,
      dots: false,
      speed: 500,
      // centerMode: true,
      slidesToScroll: 1,
      slidesToShow: 4,
      pauseOnHover: true,
      // initialSlide: 1,
      arrows: true,
      prevArrow: <CrossPrev />,
      nextArrow: <CrossNext />,
      responsive: [{
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          dots: true,
        },
      }, {
        breakpoint: 460,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      }],
    };
    // const pattern = /(\/product\/.*\/)/;
    // const current = window.location.pathname.replace(pattern, '');
    const cross = (products || []).map((obj) => {
      if (addOnsList.some(x => x.part_number === obj.part_number)) return null;
      return (<CrossBox data={obj} key={obj.part_number} url={obj.part_number} addToCart={addToCart} />);
    });

    let encabezado;
    switch (tipo) {
      case 'PREPAGO':
        encabezado = '¿Qué te parece si agregamos un plan pospago?';
        break;
      case 'PLAN':
      case 'OTRO':
        encabezado = 'Además puede interesarte';
        break;
      default:
        encabezado = '';
    }

    return (
      <section className="cross">
        <div className="cross--module" style={{ paddingLeft: '1rem' }}>
          <h2>{`${encabezado}`}</h2>
          <div className="slick--cross">
            <Slider {...crossSettings}>
              {cross}
            </Slider>
          </div>
        </div>
      </section>
    );
  } else {
    return null;
  }
};

CrossBox.propTypes = {
  data: PropTypes.shape({}),
  url: PropTypes.string,
};

export default UI;
